import './UploadedFileList.scss';

import { DeleteOutlined, DownloadOutlined, UndoOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import FileData from '@/model/General/FileData';
import { downloadFile } from '@/utils/downloadFile';

import ConfirmModal from '../ConfirmModal';

interface UploadedFileListProps {
  fileList: FileData[];
  setFileList?: Function;
  canDownload?: boolean;
}

const UploadedFileList = (props: UploadedFileListProps) => {
  const { t } = useTranslation();
  const { fileList, setFileList, canDownload = true } = props;

  return (
    fileList &&
    fileList.length > 0 && (
      <div className="UploadedFileList">
        {fileList
          .sort(a => (a.blobFile ? -1 : 1))
          .map((file, index) => (
            <div key={index} className={`FileItem ${file.removed ? 'FileRemoved' : ''}`}>
              <span>
                • {file.title}{' '}
                {file.blobFile?.size && `(${(file.blobFile.size / 1024).toFixed(2)} KB)`}
              </span>
              {canDownload && file.fileUrl && (
                <Button
                  icon={<DownloadOutlined />}
                  size="small"
                  type="text"
                  onClick={() => void downloadFile(file)}
                />
              )}
              {setFileList && !file.removed && (
                <ConfirmModal
                  openButton={
                    <Button
                      className="UploadFileDeleteButton"
                      size="small"
                      type="text"
                      icon={<DeleteOutlined />}
                    />
                  }
                  onOk={() => {
                    if (file.blobFile) {
                      setFileList(files => files.filter((_, i) => i !== index));
                    } else {
                      setFileList(files =>
                        files.map((f, i) => (i === index ? { ...f, removed: true } : f)),
                      );

                      return;
                    }
                  }}
                  message={t(`¿Estás seguro de que deseas eliminar el archivo {{fileTitle}}?`, {
                    fileTitle: file.title,
                  })}
                  title={t('Eliminar archivo')}
                />
              )}
              {file.removed && (
                <Button
                  icon={<UndoOutlined />}
                  size="small"
                  type="text"
                  onClick={() =>
                    setFileList?.(files =>
                      files.map((f, i) => (i === index ? { ...f, removed: false } : f)),
                    )
                  }
                />
              )}
            </div>
          ))}
      </div>
    )
  );
};

export default UploadedFileList;
